module.exports = __webpack_public_path__ + "61104ca9215eb2839de3b997ae926b6c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/city-9.png
 ** module id = 1045
 ** module chunks = 0
 **/